import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

import classes from './CheckIn.module.css';
import { ReactComponent as IberiaLogo } from '../../../assets/icons/logo-iberia.svg';

import Button from '../Button/Button';
import Segment from './Segment/Segment';

/*
  The state of this component is configured by the props payload json,
  this is one example of a possible state:

  this.state={
    segments:[
      {
        id:1,
        passengers:[
          {
            id:1,
            checked: true
          },
          {
            id:2,
            checked: false
          }
        ]
      },
      {
        id:2,
        passengers:[
          {
            id:1,
            checked: true
          },
          {
            id:2,
            checked: false
          }
        ]
      }
    ]
  }

*/
class CheckIn extends Component {
  constructor(props){
    super(props);
    this.state={
      segments: this.props.payload.segments.map(segment=>{
        return {
          id: segment.id,
          passengers: this.props.payload.passengers.map(pass=>{
            return {
              id: pass.id,
              checked: false,
            }
          })
        }

      }),
      formIsValid: false
    }
    
  }
 

  messageClasses = [
    classes[`${this.props.origin}-message`],
    classes.CheckIn
  ];

  confirm = (value)=>{
    const options = {
      context: {checking: 
        {
          segments: this.state.segments
        }
      }
    }
    console.log("THIS STATE: ", this.state)
    this.props.selected(value, options)
  }


  checkFormIsValid = (updatedSegments)=>{
    let valid = false;
    updatedSegments.forEach(segment=>{
      segment.passengers.forEach(pass=>{
        if (pass.checked) valid = true;
      })
    })
    console.log("checkFormIsValid: ", updatedSegments)
    return valid;
  }
 
  checkMissingSegment = (checked, segmentId, passengerId)=>{
    // checks if the previous segment for this passanger are checked, they shoud
    if (!checked) return false;

    const targetSegmentIndex = this.state.segments.findIndex((segment)=>segment.id===segmentId);
    const previousSegment= this.state.segments[targetSegmentIndex-1];
    if (!previousSegment) return false;
 
    const targetPassenger = previousSegment.passengers.find((pass)=>pass.id===passengerId);
    return !targetPassenger.checked;
  }

  checkFollowingSegment = (checked, segmentId, passengerId)=>{
    // checks if the following segment for this passanger are checked, they should not
    if (checked) return false;

    const targetSegmentIndex = this.state.segments.findIndex((segment)=>segment.id===segmentId);
    const nextSegment= this.state.segments[targetSegmentIndex+1];
    if (!nextSegment) return false;
 
    const targetPassenger = nextSegment.passengers.find((pass)=>pass.id===passengerId);
    return targetPassenger.checked;
  }


  checkPassenger = (checked, segmentId, passengerId) =>{
    // this part becomes complicated because it's mandatory to create a deep copy of any 
    // nested object or array to update the state with a new object taking care of not to
    // override the previous object pointers


    const updatedSegments = [...this.state.segments];

    const targetSegmentIndex = updatedSegments.findIndex((segment)=>segment.id===segmentId);
    const updatedSegment = {...updatedSegments[targetSegmentIndex]}

    const updatedPassengers = [...updatedSegment.passengers]
    const targetPassengerIndex = updatedPassengers.findIndex((pass)=>pass.id===passengerId);
    const updatedPassenger = {...updatedPassengers[targetPassengerIndex]};
    updatedPassenger.checked= checked;

    updatedPassengers[targetPassengerIndex]= updatedPassenger;
    updatedSegment.passengers = updatedPassengers;
    updatedSegments[targetSegmentIndex] = updatedSegment;

    // checking if the previous segment are checked too
    const missingSegment = this.checkMissingSegment(checked, segmentId, passengerId);

    // checking if following segments have to be unchecked
    const uncheckingFollowing = this.checkFollowingSegment(checked, segmentId, passengerId);
    const formIsValid = this.checkFormIsValid(updatedSegments);

    this.setState({
      segments: updatedSegments,
      formIsValid: formIsValid
    },()=>{
      if (missingSegment){
        // if prevous segments are unchecked they will be checked recursively 
        const targetSegmentIndex = this.state.segments.findIndex((segment)=>segment.id===segmentId);
        const previousSegment= this.state.segments[targetSegmentIndex-1];
        this.checkPassenger(true, previousSegment.id, passengerId)
      } 
      if (uncheckingFollowing){
        // if following segments are checked they will be unchecked recursively
        const targetSegmentIndex = this.state.segments.findIndex((segment)=>segment.id===segmentId);
        const nextSegment= this.state.segments[targetSegmentIndex+1];
        this.checkPassenger(false, nextSegment.id, passengerId)
      } 
    });

  }



  render(){
    const segments = this.props.payload.segments.map((segment, index)=>{
      const segmentState = this.state.segments.find(item=>item.id === segment.id);
      return <Segment 
        key={index} 
        payload={segment} 
        checkPassenger={this.checkPassenger}
        passengersState= {segmentState.passengers}
        passengers={this.props.payload.passengers}/>
    });



    return (
      <div 
        className={this.messageClasses.join(' ')} 
        style={this.props.style} 
        role="region" 
        tabIndex='0'
        aria-labelledby="checkInHeader">  
        <h4 id="checkInHeader" className="sr-only"> {this.props.t('checkIn.header.title')} </h4>

        <div className={classes.Header}>
          <div className={classes.HeaderLogo}>
            <IberiaLogo/>
          </div>
          <div className={classes.HeaderTitle}>
            <p className={classes.HeaderLocator} aria-label={this.props.t('checkIn.header.locator')}>{this.props.payload.locator}</p>
            <p className={classes.HeaderText}>{this.props.t('checkIn.header.text')}</p>
          </div>
        </div>
        <div className={classes.Segments}>
          {segments}
        </div>
        <div className={classes.ButtonContainer}>
          <Button 
            title={this.props.t('checkIn.button')}
            value={this.props.t('checkIn.button')}
            click={this.confirm}
            disabled={!this.state.formIsValid}
            />
        </div>
        
      </div>
    )
  }
  
}



export default withTranslation('global')(CheckIn);